export default "__VITE_ASSET__fqJ_CwvW__"